import _ from 'lodash';

const CATEGORY_NAME_MAP = {
  HORSE_RACING: 'Racing',
  GREYHOUND_RACING: 'Greyhounds',
  RUGBY_LEAGUE: 'Rugby League',
  RUGBY_UNION: 'Rugby Union',
  FORMULA_1: 'Formula 1',
  OTHER_SPORTS: 'Other Sports',
  _NFL: 'NFL'
};

const CATEGORY_PATH_MAP = {
  HORSE_RACING: "racing",
  GREYHOUND_RACING: "greyhounds",
  FORMULA_1: "formula1",
  _NFL: "nfl"
};

const underscores = /_/g;
const dash = "-";

export function categoryName(categoryId) {
  return CATEGORY_NAME_MAP[categoryId] || _.capitalize(categoryId);
}

export function categoryPath(categoryId = "") {
  return CATEGORY_PATH_MAP[categoryId] || categoryId.toLowerCase().replace(underscores, dash);
}

export function categoryUrlRoot(categoryId) {
  return categoryPath(categoryId);
}

export function categoryAdvertView(categoryId) {
  return categoryPath(categoryId);
}

export function getStoryType(routes) {
  return _.get(_.findLast(routes, route => route.storyType), 'storyType');
}

/*
  An Article can receive its article id in several ways.
  1. By being given its ID directly.
  2. Can be retrieved from the path params.
  3. An article reference which can then be looked up to find the ID.
*/
export function getArticleId(props) {

  const {
    embedded = false
  } = props;

  if (embedded) {
    const {
      articleIdRef,
      articles: {
        articleIdRefs: {
          [articleIdRef]: {
            articleIds = []
          } = {}
        } = {}
      } = {}
    } = props;

    return articleIds[0];
  } else {
    const id = props.articleId || props.params.articleId;
    return id;
  }
}



// WEBPACK FOOTER //
// ./utils/ArticleUtils.js